<template>
  <rkm-form ref="Form">
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-textarea
            label="Mensagem"
            v-model="model.mensagem"
            :validations="validations.required"
            />
        </rkm-col>
        <rkm-col cols="4">
            <rkm-form-multiselect
            :options="form.unidades"
            label="Unidade(s)"
            optionTextSelecteds="unidade selecionada"
            v-model="model.unidades"
            optionNameKey="nome"
            value-field="id"
            :selectLimit="99"
            />
        </rkm-col>
        <rkm-col cols="2">
            <rkm-form-checkbox :label="false" v-model="model.isAtivo">
            Ativar aviso?
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>

    <rkm-row>
      <rkm-col cols="6">
        <rkm-form-date-picker
          :min-date="additionals.minData"
          :max-date="additionals.maxData"
          :range-inline="false"
          :start-validations="validations.periodo"
          :end-validations="validations.periodo"
          end-label="Até"
          range
          start-label="Período de"
          v-model="model.periodo"
        />
      </rkm-col>

      <rkm-col cols="3">
        <rkm-form-time-picker
          :validations="validations.required"
          label="Hora inicial"
          v-model="model.horaInicial"
        />
      </rkm-col>

      <rkm-col cols="3">
        <rkm-form-time-picker
          :validations="validations.required"
          label="Hora final"
          v-model="model.horaFinal"
        />
      </rkm-col>
    </rkm-row>
    <rkm-row>
      <rkm-col cols="6">
        <rkm-form-checkbox-group
          button-color="outline-primary"
          buttons
          class="dias-semana"
          label="Dias da semana"
          :options="form.diasSemana"
          text-field="descricao"
          value-field="id"
          v-model="model.diasSemana"
          :validations="validations.required"
        />
      </rkm-col>
      <rkm-col cols="6">
        <rkm-form-radio-group
          :options="form.intervalos"
          button-color="outline-primary"
          buttons
          label="Intervalos"
          text-field="descricao"
          value-field="valor"
          v-model="model.intervalo"
          :validations="validations.required"
        />
      </rkm-col>
    </rkm-row>
  </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from "vuex";

// Mixins.
import { repository, object, error, stringCase, data, request } from "@/mixins";

export default {
  computed: {
    validations() {
      return {
        required: { required: true },
        periodo: { required: true },
      };
    },
  },
  created() {
    this.repositories = {
      aviso: this.getConectaSusRepository("painelSenha.aviso"),
    };
  },
  data: () => ({
    form: {},
    additionals: {},
    model: {
        unidades: [],
      periodo: {
        start: null,
        end: null,
      }
    },
  }),
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    load() {

      this.setLoading();

      const request = this.id
        ? this.repositories.aviso.edit(this.id)
        : this.repositories.aviso.create();

      request
        .then(({ data }) => {
            this.form = this.clone(data.form);
            this.model = this.clone(data.model);

            this.additionals = this.clone(data.additionals);

            if(!this.id) {
                return;
            }

            this.$nextTick(() => {
                this.model.unidades = data.model.unidades;
            });
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    save() {
      this.$refs.Form.validate().then((valid) => {
        if (!valid) return;

        if (this.model.unidades.length === 0) {
          this.showWarningNotification("Escolha ao menos uma unidade.");
          return;
        }

        this.setLoading();

        const request = this.id
          ? this.repositories.aviso.update(this.id, this.prepareData())
          : this.repositories.aviso.store(this.prepareData());

        request
          .then((response) => {
            this.showSaveNotification();
            this.$emit("save", response);
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      });
    },
    prepareData() {
      return this.camelObjectKeysToSnakeRecursive(this.clone(this.model));
    },
  },
  props: {
    id: { type: Number, default: null },
  },
  mixins: [repository, object, error, stringCase, data, request],
  mounted() {
    this.load();
  },
};
</script>
